import { GraphQLService } from './graphql-service.ts';
import {
  PartialAppContext,
  SsrAppContext
} from '../../../shared/source/components/app-context/app-context.tsx';

export type GraphQLServiceType = 'intern' | 'public';

export const createGraphQLService = (
  context: PartialAppContext<SsrAppContext, 'logger'>,
  type: GraphQLServiceType
): GraphQLService => {
  // Due to the current issue that Deno cant be used in the browser,
  // we are using hardcoded endpoints for the GraphQL service.
  // In production, these should be replaced with environment variables.
  // This was found in dish.tsx with the likeDish function.
  // const internEndpoint = 'http://sk-stage.nomad.gutefrage.team/gm/graphql/app';
  // const publicEndpoint = 'https://stage.speisekarte.de/gm/graphql/app';
  const internEndpoint = Deno.env.get('GRAPHQL_INTERN_ENDPOINT') ?? null;
  const publicEndpoint = Deno.env.get('GRAPHQL_PUBLIC_ENDPOINT') ?? null;

  if (internEndpoint === null || publicEndpoint === null) {
    throw new Error('GraphQL endpoints are not configured. Please check configuration.');
  }

  const endpoints: Record<GraphQLServiceType, string> = {
    intern: internEndpoint,
    public: publicEndpoint
  };

  return new GraphQLService(context, endpoints[type]);
};
